exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".buttonRegisterColor {\n  background-color: gray; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/security/security/login-and-register/login-and-register.component.scss
// module id = xwO9
// module chunks = 2